import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { countriesListResolver } from '@df/api/config/contries-list.resolver';
import { SamplesCheckoutSuccessResolver } from '@df/samples/samples-checkout-success.resolver';
import { SamplesCheckoutResolver } from '@df/samples/samples-checkout.resolver';
import { SamplesLoadBasketResolver } from '@df/samples/samples-load-basket.resolver';
import { CustomerResolver } from '@df/session/customer/customer.resolver';
import { CheckoutFormCmsComponent } from './../checkout/form/checkout-form-cms.component';
import { CheckoutFormCmsResolver } from './../checkout/form/checkout-form-cms.resolver';
import { SamplesCheckoutSuccessCmsResolver } from './success/samples-checkout-cms.resolver';
import { SamplesCheckoutSuccessCmsComponent } from './success/samples-checkout-success-cms.component';
import { SamplesCheckoutSuccessComponent } from './success/samples-checkout-success.component';
@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                component: CheckoutFormCmsComponent,
                resolve: {
                    appMore: countriesListResolver,
                    samplesBasket: SamplesLoadBasketResolver,
                    checkoutData: SamplesCheckoutResolver,
                    layout: CheckoutFormCmsResolver
                }
            },
            {
                path: 'success',
                component: SamplesCheckoutSuccessCmsComponent,
                resolve: {
                    customer: CustomerResolver,
                    checkoutSuccessData: SamplesCheckoutSuccessResolver,
                    layout: SamplesCheckoutSuccessCmsResolver
                }
            }
        ]),
        SamplesCheckoutSuccessCmsComponent, SamplesCheckoutSuccessComponent
    ],
    declarations: []
})
export class SamplesCheckoutModule {
}
